import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { EditSubCategory } from "../types";

type Params = {
	portalId: number;
};

const fetchEditSubCategories = async (portalId: number): Promise<EditSubCategory[]> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getEditCategories",
		bind: {
			portalId,
		},
	});

	return response.data.result;
};

export const useGetEditSubCategories = ({ portalId }: Params) => {
	return useQuery<EditSubCategory[]>({
		queryKey: ["getEditCategories", portalId],
		queryFn: () => fetchEditSubCategories(portalId),
		enabled: !!portalId,
	});
};
